webpackJsonp([188213976027546],{

/***/ 3991:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),

/***/ 3993:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),

/***/ 4015:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.lastIndexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictLastIndexOf(array, value, fromIndex) {
	  var index = fromIndex + 1;
	  while (index--) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return index;
	}
	
	module.exports = strictLastIndexOf;


/***/ }),

/***/ 4026:
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(3991),
	    baseIsNaN = __webpack_require__(3993),
	    strictLastIndexOf = __webpack_require__(4015),
	    toInteger = __webpack_require__(719);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * This method is like `_.indexOf` except that it iterates over elements of
	 * `array` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=array.length-1] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.lastIndexOf([1, 2, 1, 2], 2);
	 * // => 3
	 *
	 * // Search from the `fromIndex`.
	 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	 * // => 1
	 */
	function lastIndexOf(array, value, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = length;
	  if (fromIndex !== undefined) {
	    index = toInteger(fromIndex);
	    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	  }
	  return value === value
	    ? strictLastIndexOf(array, value, index)
	    : baseFindIndex(array, baseIsNaN, index, true);
	}
	
	module.exports = lastIndexOf;


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(207);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(718);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(382);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lastIndexOf = __webpack_require__(4026);
	
	var _lastIndexOf2 = _interopRequireDefault(_lastIndexOf);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Divider = __webpack_require__(212);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Tags = __webpack_require__(287);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _ShareBar = __webpack_require__(368);
	
	var _ShareBar2 = _interopRequireDefault(_ShareBar);
	
	var _Meta = __webpack_require__(48);
	
	var _theme = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _extends2, _thumbnail, _downloadBtn, _title, _customerName, _paginateButton;
	
	  return {
	    content: _extends({}, (0, _theme.pageStyle)(theme), (_extends2 = {
	      margin: 0,
	      padding: 10,
	      width: 700
	    }, _extends2[theme.breakpoints.down('sm')] = {
	      width: '90%'
	    }, _extends2)),
	    thumbnail: (_thumbnail = {
	      width: '100%',
	      height: 430,
	      objectFit: 'cover'
	    }, _thumbnail[theme.breakpoints.down('sm')] = {
	      height: '100%'
	    }, _thumbnail),
	    downloadBtn: (_downloadBtn = {
	      color: '#fff',
	      background: theme.palette.text.review,
	      '&:hover': {
	        background: theme.palette.primary.main
	      }
	    }, _downloadBtn[theme.breakpoints.down('xs')] = {
	      fontSize: '0.85em'
	    }, _downloadBtn),
	    title: (_title = {
	      fontWeight: 600,
	      color: theme.palette.primary.main,
	      paddingTop: 10
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em'
	    }, _title),
	    customerName: (_customerName = {
	      fontSize: '1.1em',
	      color: theme.palette.text.soft
	    }, _customerName[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _customerName),
	    paginateButton: (_paginateButton = {
	      textTransform: 'none',
	      background: theme.palette.primary.dark,
	      transition: 'color 0.5s, background 0.5s',
	      color: '#fff',
	      margin: '0 ' + theme.spacing.unit + 'px',
	      padding: 'auto 25px',
	      borderRadius: theme.spacing.unit * 5,
	      boxShadow: 'none',
	      '&:hover': {
	        color: theme.palette.primary.dark,
	        background: theme.palette.borders.ghost
	      }
	    }, _paginateButton[theme.breakpoints.down('xs')] = {
	      width: '100%',
	      fontSize: '0.8em'
	    }, _paginateButton),
	    tagsContainer: {
	      minHeight: 35,
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center'
	    }
	  };
	};
	
	var ProductCustomerReviewTemplate = function ProductCustomerReviewTemplate(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      data = _ref.data,
	      pathContext = _ref.pathContext;
	  var reviewBody = pathContext.reviewBody;
	  var customerReview = data.customerReview,
	      file = data.file;
	
	  var baseUrl = 'https://healthfulinspired.com';
	
	  var datePublished = new Date(customerReview.frontmatter.date).toISOString();
	  var dateModified = file.modifiedTime;
	  var downloads = { pdf: [], doc: [], docx: [] // to be updated
	
	  };if (customerReview.frontmatter.downloads) {
	    customerReview.frontmatter.downloads.reduce(function (acc, val) {
	      var ext = val.slice((0, _lastIndexOf2.default)(val, '.') + 1);
	      if (ext === 'pdf') {
	        acc.pdf.push(val);
	      }
	      if (ext === 'doc') {
	        acc.doc.push(val);
	      }
	      if (ext === 'docx') {
	        acc.docx.push(val);
	      }
	      return acc;
	    }, downloads);
	  }
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    {
	      id: 'productCustomerReviewPage',
	      spacing: 24,
	      justify: 'center',
	      alignItems: 'center',
	      style: { padding: '20px 0' },
	      container: true
	    },
	    _react2.default.createElement(_Meta.ArticleMeta, {
	      title: customerReview.frontmatter.title,
	      shortDescription: customerReview.frontmatter.shortDescription,
	      thumbnail: customerReview.frontmatter.thumbnail,
	      genre: 'health',
	      tags: customerReview.frontmatter.tags,
	      wordCount: customerReview.wordCount.words,
	      datePublished: datePublished,
	      dateModified: dateModified,
	      articleBody: reviewBody,
	      excerpt: customerReview.excerpt,
	      path: customerReview.fields.slug
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { className: classes.content, item: true },
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          variant: 'display1',
	          align: 'center',
	          classes: { display1: classes.title }
	        },
	        customerReview.frontmatter.title
	      ),
	      customerReview.frontmatter.downloads && _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', paddingBottom: 15 } },
	        downloads.pdf.length && downloads.pdf.map(function (url) {
	          return _react2.default.createElement(
	            'a',
	            { key: url, href: url, target: '_blank' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: classes.downloadBtn,
	                size: 'small',
	                variant: 'raised'
	              },
	              'Available in PDF'
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { align: 'center', className: classes.customerName },
	        'Written by customer:',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { style: { color: '#772c4f' } },
	          _react2.default.createElement(
	            'b',
	            null,
	            customerReview.frontmatter.customerName
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          align: 'center',
	          style: {
	            color: theme.palette.text.light,
	            fontStyle: 'italic',
	            paddingBottom: 15
	          }
	        },
	        customerReview.timeToRead,
	        ' min read'
	      ),
	      _react2.default.createElement('img', {
	        className: classes.thumbnail,
	        src: customerReview.frontmatter.customerPhoto || customerReview.frontmatter.thumbnail,
	        alt: customerReview.frontmatter.title,
	        title: customerReview.frontmatter.title
	      }),
	      _react2.default.createElement(_ShareBar2.default, {
	        baseUrl: baseUrl,
	        url: '' + baseUrl + customerReview.fields.slug,
	        thumbnail: customerReview.frontmatter.thumbnail,
	        title: customerReview.frontmatter.title,
	        excerpt: customerReview.excerpt,
	        tags: customerReview.frontmatter.tags
	      }),
	      _react2.default.createElement('div', {
	        className: 'markdown',
	        dangerouslySetInnerHTML: { __html: customerReview.html }
	      }),
	      _react2.default.createElement(_Divider2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: classes.tagsContainer },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'body2' },
	            'tags: \xA0'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Tags2.default, { tags: customerReview.frontmatter.tags })
	        )
	      )
	    ),
	    _react2.default.createElement('script', { async: true, defer: true, src: 'http://www.instagram.com/embed.js' }),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        div.markdown img {\n          width: 100%;\n          max-height: 350px;\n          object-fit: cover;\n          border: 1px solid ' + theme.palette.borders.cloudier + ';\n        }\n        div.markdown {\n          color: ' + theme.palette.text.review + ';\n        }\n        table {\n          border: 1px solid ' + theme.palette.primary.main + ';\n        }\n        table th {\n          background: ' + theme.palette.primary.main + ';\n          color: #fff;\n          padding: 10px;\n        }\n        table td {\n          border: 1px solid ' + theme.palette.borders.cloud + ';\n        }\n        h1, h2, h3, h4, h5, h6 {\n          line-height: 1em;\n        }\n        h1 {\n          padding: 20px 0;\n        }\n        .instagram-media {\n          margin: auto !important;\n        }\n        @media (max-width: 600px) {\n          div.markdown h1, h2, h3 {\n            font-size: 1.4em;\n          }\n          div.markdown img {\n            height: 100%;\n          }\n        }\n      '
	    )
	  );
	};
	
	ProductCustomerReviewTemplate.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    reviewBody: _propTypes2.default.string.isRequired
	  }).isRequired
	
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(ProductCustomerReviewTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-customer-review-js-d676f5888fda40437826.js